import React from 'react';
import { CalendarPlus } from 'lucide-react';

interface GoogleCalendarButtonProps {
  url: string;
  title?: string;
  className?: string;
  onClick?: () => void;
}

export const GoogleCalendarButton: React.FC<GoogleCalendarButtonProps> = ({
  url,
  title = 'Adicionar ao Google Calendar',
  className = '',
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick();
    window.open(url, '_blank');
  };

  return (
    <button
      type="button"
      title={title}
      onClick={handleClick}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium bg-primary/10 text-primary hover:bg-primary/20 transition-colors ${className}`}
    >
      <CalendarPlus size={14} />
      <span>Google Calendar</span>
    </button>
  );
};
